export default {
    goals        : state => state.goals,
    goalsArr     : state => state.goals.goals,
    selectedGoal : state => state.selectedGoal,
    filter       : state => state.filter,
    managersGoals: state => state.managerGoals
};
